import {
  useLinkToolbarButton,
  useLinkToolbarButtonState,
} from "@platejs/link/react";
import { ButtonWrapper } from "./_Button";
import FontAwesome from "../../../utilities/FontAwesome";

export const LinkButton = ({ showTooltip }) => {
  const state = useLinkToolbarButtonState();
  const { props: buttonProps } = useLinkToolbarButton(state);

  return (
    <ButtonWrapper
      tooltip={showTooltip ? "Add Link" : undefined}
      {...buttonProps}
    >
      <FontAwesome prefix={"fas"} name={"fa-link"} />
    </ButtonWrapper>
  );
};
